import { Accordion, Mobile, TRANSITION_END, Carousel_CoreInit } from './core'
import './modules/header'
import './modules/contact-form'
import './plugins/menu-component'

$(function() {
  Carousel_CoreInit([
    {
      classSelector: 'menu-component-carousel',
      swiperOptions: {
        breakpoints: {
          0: {
            slidesPerView: 'auto',
          },
        },
      },
    },
  ]);
  $.mlmi = {
    mobile: new Mobile(),
    scroller: $(window).ScrollEvents()
  }

  /* Accordions */
  Accordion.init()

  /* Header */
  $('.header').each(function() {
    $(this).Header()
  })

  /* Menu component */
  $('.menu-component').each(function() {
    $(this).MenuComponent()
  })

  /* Contact form */
  $('.contact-form').each(function() {
    $(this).ContactForm()
  })

  /* Picture border */
  $('.text-content .picture').each(function() {
    if ($(this).closest('.col').hasClass('order-md-1')) {
      $(this).wrap('<div class="image-border-left"></div>')
    }
    var count = $(this).closest('.row').find('.col').length;
    if ($(this).closest('.col').hasClass('order-md-' + count)) {
      $(this).wrap('<div class="image-border-right"></div>')
    }
  })

  // Display empty accordion as item list
  $('.accordion__panel-content').each(function() {
    if (!$(this).html().trim()) {
      $(this).closest('.js-accordion__item').addClass('--empty');
      $(this).closest('.js-accordion__panel').remove();
    }
  })
})
